module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Socket-eu-4eadc262d3a27430c27b618d8c7d5e83.svg";